import React, { useMemo, useState } from "react";
import { Avatar } from "@components/tailwindComponents";
import { BLANK_PROFILE_PICTURE } from "@helpers/_constants";
import Badge from "@shared/employeFormNew/JobAndSalary/SharedDisciplinary/BadgeDisciplinary";
import BlackTooltip from "@components/tooltip/BlackTooltip";
import { SvgMenuExpenses } from "@routes/IconeSvg";
import file_carrer from "@assets/image/icones/carrer/file_carrer.svg";
import notif_certification from "@assets/image/icones/carrer/notif_certification.svg";
import moment from "moment-timezone";
import SharedViewFile from "@components/modals/SharedViewFile";

const DisciplinaryItemTable = ({ disciplinary, translator, i18n }) => {
    const [sharedViewFile, setShowFile] = useState(false);
    const [file, setFile] = useState({});
    const disciplinaryStyles = useMemo(() => ({
        Event: {
            bgColorStatus: "arh-bg-[#E2F1FE]",
            bgCircleStatus: "arh-bg-[#265985]",
            textColorStatus: "arh-text-[#265985]",
            titleEvent: translator("Événement"),
        },
        Communication: {
            bgColorStatus: "arh-bg-[#FBEED6]",
            bgCircleStatus: "arh-bg-[#F29D0E]",
            textColorStatus: "arh-text-[#F29D0E]",
            titleEvent: translator("Communication"),
        },
        Sanction: {
            bgColorStatus: "arh-bg-[#F9E6DD]",
            bgCircleStatus: "arh-bg-[#C24E27]",
            textColorStatus: "arh-text-[#C24E27]",
            titleEvent: translator("Sanction"),
        },
    }), []);

    const disciplinaryStyle = useMemo(() => (
        disciplinaryStyles[disciplinary?.typeEvent]
    ), [disciplinary?.typeEvent, disciplinaryStyles]);

    const periodDisciplinary = moment(disciplinary.startDate)
        .locale(i18n.language)
        .format("LL"
        )
        + (moment(disciplinary.endDate).isValid()
            ? ` - ${moment(disciplinary.endDate)
                .locale(i18n.language)
                .format("LL"
                )}`
            : "");

    const onClickShowFile = (file) => {
        setShowFile(!sharedViewFile);
        setFile(file);
    };

    return (
        <>
            <tr className="arh-border arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-greyBorderInput arh-px-5 arh-text-xs hover:arh-bg-greyColor">
                <td className="arh-px-5 arh-py-3 arh-text-xs ">
                    <Avatar
                        src={disciplinary.employer?.profileImage || BLANK_PROFILE_PICTURE}
                        name={disciplinary.employer?.fullname}
                        textStyle="desktop-middle:arh-w-24 arh-max-w-[12rem] arh-truncate arh-font-poppins arh-font-medium arh-text-xs !arh-text-[#5a5a5a]"
                    />
                </td>
                <td className="arh-px-5 arh-py-3 arh-text-xs ">
                    <BlackTooltip
                        title={<p
                            className="arh-m-0 arh-w-full"
                            style={{
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 5,
                                fontSize: "12px"
                            }}
                        >
                            {disciplinary?.title}
                        </p>}
                        placement="top"
                    >
                        <div className="arh-w-full arh-truncate arh-max-w-[12rem]">
                            {disciplinary?.title}
                        </div>
                    </BlackTooltip>
                </td>
                <td className="arh-px-5 arh-py-3 arh-text-xs ">
                    <Badge
                        bgColorStatus={disciplinaryStyle.bgColorStatus}
                        bgCircleStatus={disciplinaryStyle.bgCircleStatus}
                        textColorStatus={disciplinaryStyle.textColorStatus}
                        titleEvent={disciplinaryStyle.titleEvent}
                    />
                </td>
                <td className="arh-px-5 arh-py-3 arh-text-xs ">
                    {disciplinary?.category?.name || "-"}
                </td>
                <td className="arh-px-5 arh-py-3 arh-text-xs ">
                    {disciplinary?.gradation?.name || "-"}
                </td>
                <td className="arh-px-5 arh-py-3 arh-text-xs ">
                    <BlackTooltip title={periodDisciplinary} placement="top">
                        <div className="arh-block arh-w-full arh-truncate">
                            {periodDisciplinary}
                        </div>
                    </BlackTooltip>
                </td>
                <td className="arh-px-5 arh-py-3 arh-text-xs ">
                    {disciplinary?.notes ? (
                        <BlackTooltip
                            title={
                                <p
                                    className="arh-m-0 arh-w-full"
                                    style={{
                                        overflow: "hidden",
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: 10,
                                        fontSize: "12px"
                                    }}
                                >
                                    {disciplinary.notes}
                                </p>
                            }
                            placement="top"
                        >
                            <img alt="file_carrer" src={file_carrer} />
                        </BlackTooltip>
                    ) : (
                        "-"
                    )}
                </td>
                <td className="arh-px-5 arh-py-3 arh-text-xs ">
                    {disciplinary?.files?.length > 0
                        ? disciplinary?.files?.map((file) => (
                            <BlackTooltip
                                title={file?.filename}
                                placement="top"
                                key={file?._id}
                            >
                                <div
                                    className="arh-flex arh-items-center arh-justify-start arh-space-x-2 arh-w-full arh-cursor-pointer"
                                    onClick={() => onClickShowFile(file)}
                                >
                                    <span>{SvgMenuExpenses()}</span>
                                    <span className="arh-block arh-w-full arh-max-w-[10rem] arh-truncate arh-underline">
                                        {file?.filename}
                                    </span>
                                </div>
                            </BlackTooltip>
                        ))
                        : "-"}
                </td>
                <td className="arh-px-5 arh-py-3 arh-text-xs ">
                    {disciplinary.alertDate && moment(disciplinary.alertDate).isValid() ? (
                        <BlackTooltip
                            title={moment(disciplinary.alertDate)
                                .locale(i18n.language)
                                .format("LL")}
                            placement="top"
                        >
                            <div className="arh-flex arh-w-full arh-cursor-pointer arh-items-center arh-justify-start arh-space-x-2">
                                <span>
                                    <img alt="notif_certification" src={notif_certification} />
                                </span>
                                <span className="arh-block arh-w-full arh-truncate">
                                    {moment(disciplinary.alertDate)
                                        .locale(i18n.language)
                                        .format("LL")}
                                </span>
                            </div>
                        </BlackTooltip>
                    ) : (
                        "-"
                    )}
                </td>
            </tr>
            <SharedViewFile
                onClickClose={onClickShowFile}
                show={sharedViewFile}
                file={file}
                t={translator}
            />
        </>
    );
};

export default DisciplinaryItemTable;
